export default {
    URL_PASSWORD: '/Cuenta/password',
}